export class ComponentWorker {
    constructor(name, props) {
        this.name = name;
        this.worker = props.worker;
    }
}